import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import orderitemModel from "../../models/orderitem.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import {
  Button,
  Dropdown,
  ToggleButton,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment/moment";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Page = function () {
  const [showLoader, setShowLoader] = useState(false);

  const router = useRouter();

  const queryParams = router.query;
  queryParams.order_by = queryParams.order_by ?? "created_at";
  queryParams.order_in = queryParams.order_in ?? "desc";
  queryParams.status = queryParams.status ?? "";

  const {
    data: ordersData,
    mutate: reloadordersData,
    isLoading,
  } = useSWR(
    queryParams || null,
    () => orderitemModel.list(queryParams),
    config.swrConfig,
  );

  function statusFilter(status) {
    queryParams.status = status;
    queryParams.page = 1;
    router.push({ query: queryParams });
  }

  const onSubmitFilter = (data) => {
    const params = {
      ...router.query,
      ...data,
      startdate: startDate ? helper.date.format(startDate, "YYYY-MM-DD") : "",
      enddate: endDate ? helper.date.format(endDate, "YYYY-MM-DD") : "",
      page: 1, // reset pagination when applying filters
    };

    router.push({ query: params }); // 🔥 this updates the URL & triggers SWR re-fetch
    handleCloseAdvancedFilter(); // close modal after saving
  };


 const columns = [
    {
      Header: "Order Id",
      accessor: "sub_order_id",
    },
    {
      Header: "Product",
      accessor: "product",
      Cell: ({ row }) => (
        <>
          <b>{row.original?.sku}</b>
          <br />
          <span className="small">{row.original?.title}</span>
        </>
      ),
    },
    {
      Header: "Name",
      accessor: "order.name",
      className: "col",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Amount",
      id: "selling_price",
      Cell: ({ row }) => (
        <>{helper.currency.format(row.original?.selling_price)}</>
      ),
    },
    {
      Header: "City",
      id: "city",
      Cell: ({ row }) => (
        <>
          {row.original?.order?.city}, {row.original?.order?.state}
        </>
      ),
    },
    {
      Header: "AWB",
      id: "awb",
      Cell: ({ row }) => <>{row.original?.awb_number}</>,
    },
    {
      Header: "Payment",
      Cell: ({ row }) => (
        <>
          {row.original?.order?.payment_mode == "cod" ? (
            "COD"
          ) : (
            <>
              {row.original?.order?.payment_mode}
              <br />
              {row.original?.order?.payment_status}
            </>
          )}
        </>
      ),
      className: "col",
    },
    {
      Header: "Status",
      Cell: ({ row }) => <>{row.original?.order?.status}</>,
      className: "col",
    },
    {
      Header: "Created At",
      accessor: "created_at",
      Cell: ({ row }) => <>{helper.date.format(row.original?.created_at)}</>,
    },
    
  ];

  return (
    <>
      <Heading title="Order-items" showLoader={isLoading || showLoader}>
        {console.log()}
      </Heading>
      <div className="container-fluid">
        <div className="btn-group m-1 overflow-scroll w-100 text-nowrap">
          <ToggleButton
            key="btn-all"
            id={`radio-btn-all}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == ""}
            onChange={(e) => {
              statusFilter("");
            }}
          >
            All
          </ToggleButton>

          <ToggleButton
            key="btn-booked"
            id={`radio-booked}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "booked"}
            onChange={(e) => {
              statusFilter("booked");
            }}
          >
            Booked
          </ToggleButton>
          <ToggleButton
            key="btn-packed"
            id={`radio-packed}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "packed"}
            onChange={(e) => {
              statusFilter("packed");
            }}
          >
            Packed
          </ToggleButton>
          <ToggleButton
            key="btn-shipped"
            id={`radio-shipped}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "shipped"}
            onChange={(e) => {
              statusFilter("shipped");
            }}
          >
            Shipped
          </ToggleButton>
          <ToggleButton
            key="btn-intransit"
            id={`radio-intransit}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "in_transit"}
            onChange={(e) => {
              statusFilter("in_transit");
            }}
          >
            In Transit
          </ToggleButton>
          <ToggleButton
            key="btn-delivered"
            id={`radio-delivered}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "delivered"}
            onChange={(e) => {
              statusFilter("delivered");
            }}
          >
            Delivered
          </ToggleButton>
          <ToggleButton
            key="btn-cancelled"
            id={`radio-cancelled}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "cancel"}
            onChange={(e) => {
              statusFilter("cancel");
            }}
          >
            Cancelled
          </ToggleButton>
          <ToggleButton
            key="btn-rto"
            id={`radio-rto}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "rto"}
            onChange={(e) => {
              statusFilter("rto");
            }}
          >
            RTO
          </ToggleButton>
          <ToggleButton
            key="btn-return"
            id={`radio-return}`}
            type="radio"
            variant="outline-secondary"
            name="radio"
            value=""
            checked={queryParams.status == "return"}
            onChange={(e) => {
              statusFilter("return");
            }}
          >
            Return
          </ToggleButton>
        </div>
        <div className="card">
          <div className="card-header">Order items</div>

          <div className="table-responsive">
            <Table columns={columns} data={ordersData?.data || []} />
          </div>
          <div className="card-footer table-responsive">
            <Pagination meta={ordersData?.meta} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Page;
